export default __webpack_public_path__ + "static/media/logo2.970d035b.png";